/**
 * Route for `fraud-blacklist-synchronization-across-vendors`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudBlacklistSynchronizationAcrossVendorsPage } from "../features/fraud-blacklist-synchronization-across-vendors/FraudBlacklistSynchronizationAcrossVendorsPage";

export const fraudBlacklistSynchronizationAcrossVendorsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-blacklist-synchronization-across-vendors",
	component: FraudBlacklistSynchronizationAcrossVendorsPage,
});

export default fraudBlacklistSynchronizationAcrossVendorsRoute;
